var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Tencent",on:{"click":_vm.openTencent}},[_c('el-avatar',{staticClass:"Tencent-header",attrs:{"size":40,"src":_vm.circleUrl}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("在线"),_c('br'),_vm._v("咨询")])
}]

export { render, staticRenderFns }